import { memo, useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'

import { OutOfMinutesModal } from '../../../components/Modals/OutOfMinutesModal'
import { useRemaining } from './useRemaining'

interface IReminderProps {
  isHidden: boolean
  secondsBalance: number
  isSocketConnected: boolean
  setOutOfCreditsShown: (value: boolean) => void
}
const Reminder: React.FC<IReminderProps> = memo(
  ({ isHidden, secondsBalance, isSocketConnected, setOutOfCreditsShown }) => {
    const [showModal, setShowModal] = useState(false)

    const { containerId, isRunning } = useRemaining(
      secondsBalance,
      isSocketConnected,
    )

    useEffect(() => {
      if (secondsBalance === 0 && isRunning) {
        setShowModal(true)
        setOutOfCreditsShown(true)
      }
    }, [secondsBalance, isRunning])

    return (
      <>
        {showModal && (
          <OutOfMinutesModal
            onClose={() => setShowModal(false)}
            isSessionPage
          />
        )}
        <ToastContainer
          containerId={containerId}
          position="top-right"
          limit={1}
          className={isHidden ? 'hidden' : ''}
        />
      </>
    )
  },
)

export { Reminder }
